<template>
  <div class="home">
    <div class="container my-3 py-3 px-4">
      <div class="row">
        <div class="col-12">
          <h2 class="text-start">Users</h2>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-3 col-lg-3 ms-auto">
          <button
            class="btn btn-primary w-100"
            @click="goToCreateNewUser">
            <i class="bi bi-plus-circle-fill"></i> Create New User
          </button>
        </div>
      </div>
      <div>
        <div class="row">
          <div class="col-12 col-lg-4 mb-4">
            <ca-smtt-input
              type="text"
              label="Search"
              placeholder="Search by username or app name"
              iconClear
              @clearInput="(e) => this.userSearchOptions = e"
              @input="handleSearchUsers"
            />
          </div>
        </div>

        <div class="row"
          v-if="filteredUsers.length === 0"
        >
          <div class="col-12 text-uppercase">
            users not found
          </div>
        </div>

        <div
          v-else
          class="row"
          :class="{
            'px-4': mobileDisplay
          }"
        >
          <table
            class="table table-responsive table-hover text-start rounded-3"
          >
            <thead id="table-headers" class="table-primary">
              <tr>
                <th scope="col">Username</th>
                <th scope="col">Full Name</th>
                <th scope="col">Apps Allowed</th>
                <th scope="col">Status</th>
                <th scope="col" class="text-center">Actions</th>
              </tr>
            </thead>
            <tbody id="table-body">
              <tr
                class="text-start cursor-pointer"
                v-for="(filteredUser, index) in filteredUsers" :key="index"
                :title="`Go to ${filteredUser.name} ${filteredUser.last_name} details`"
                @click="goToEditUser($event, filteredUser.id)"
              >
                <td header="Username" scope="row" class="word-wrap"> {{ filteredUser.username ? filteredUser.username : '<TBD>' }} </td>
                <td header="Full Name"> 
                  {{ filteredUser.name ? filteredUser.name : '<TBD>'}}
                  {{ filteredUser.last_name ? filteredUser.last_name : '<TBD>' }} 
                </td>
                <td header="Apps Allowed">
                  {{
                    filteredUser.sites.map(site => site.site).length > 0
                      ? filteredUser.sites.map(site => site.site).join(', ')
                      : 'No sites allowed yet.'
                  }}
                </td>
                <td header="Status"> {{ filteredUser.is_available ? 'Active' : 'Inactive' }} </td>
                <td header="Actions" class="d-flex justify-content-start justify-content-xl-evenly">
                  <button
                    class="btn btn-label"
                    title="Edit user"
                    @click="goToEditUser($event, filteredUser.id)"
                  >
                    <i class="bi bi-pencil-square"></i>
                  </button>
                  <button
                    v-if="filteredUser.email !== user.email"
                    class="btn btn-label"
                    :title="filteredUser.is_available ? 'User enabled' : 'User disabled'"
                    @click="toggleUserAvailability($event, filteredUser)"
                  >
                    <i v-if="filteredUser.is_available" class="bi bi-toggle-on"></i>
                    <i v-else class="bi bi-toggle-off"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import caSmttInput from '@/components/ca-smtt-input.vue'
import { getUsers } from '@/services/users/user.api.js'
import { toggleIsAvailable } from '@/services/users/user.api.js'
import { mapState } from 'vuex'

export default {
  components: { caSmttInput },
  name: 'Home',
  data() {
    return {
      users: [],
      sites: [],
      sitesTypes: [],
      userSearchOptions: [],
      sitesSearchOptions: [],
      sitesTypesSearchOptions: [],
      dropdownText: null,
      linkRegExp: /^(ftp|http|https):\/\/[^ "]+$/,
    }
  },
  async mounted() {
    await this.showUsersTable();
  },
  methods: {
    async showUsersTable(){
      this.dropdownText = 'Users'
      this.$store.commit('setMainScreenDropdown', 'Users')
      this.sites = []
      this.sitesTypes = []
      try {
        const {data} = await getUsers()
        this.users = data.users.filter(user => user.id !== this.user.id)
      } catch (error) {
        console.log(error)
      }
    },
    async toggleUserAvailability(event, userData) {
      event.stopPropagation();
      try {
        await toggleIsAvailable(userData.id)
        // toast
        this.$toast.open({
          message: !userData.is_available ? 'User Enabled' : 'User Disabled',
          type: 'info'
        })
        // re-render
        await this.showUsersTable()
      } catch (error) {
        console.log(error)
        this.$toast.open({
          message: 'An error occurred',
          type: 'error'
        })
      }
    },
    goToCreateNewUser() {
      this.$router.push(`/user/create`)
    },
    goToEditUser(event, userId) {
      event.stopPropagation();
      this.$router.push(`/user/edit/${userId}`)
    },
    handleSearchUsers(event) {
      this.userSearchOptions = event.target.value
    },
  },
  computed: {
    ...mapState(['mobileDisplay', 'user']),
    filteredUsers() {
      return this.userSearchOptions.length > 0 ?
        this.users.filter(user => {
          if (user.username.toLowerCase().includes(this.userSearchOptions.toLowerCase())) {
            return user
          }
          if (user.sites.some(site => site.site.toLowerCase().includes(this.userSearchOptions.toLowerCase()))) {
            return user
          }
        }
        ) :
        this.users
    },
  }
}
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}
</style>